import { EventTypes } from 'redux-segment';

import H from 'constants/httpMethod.const';
import { AUTH_API } from 'middleware/api';
import authenticatedEndpoint from 'utils/backend/authenticatedEndpoint.util';
import jsonEndpoint from 'utils/backend/jsonEndpoint.util';
import logger from 'utils/logger.util';
import asObject from 'utils/objects/asObject.util';

import { FETCH_SALON_TAGS_LIST_FAILURE, FETCH_SALON_TAGS_LIST_REQUEST, FETCH_SALON_TAGS_LIST_SUCCESS } from './fetchSalonTagsList.types';

const ATAG = 'fetchSalonTagsList';
const L = logger(ATAG);

const fetchSalonTagsList = L.wrap('()', (options) => ({
  ATAG,
  [AUTH_API]: {
    ...authenticatedEndpoint(),
    ...jsonEndpoint(H.get, `salon/v2/${asObject(options).salonId}/client_tags/`),
    types: [FETCH_SALON_TAGS_LIST_REQUEST, FETCH_SALON_TAGS_LIST_SUCCESS, FETCH_SALON_TAGS_LIST_FAILURE],
    meta: { analytics: EventTypes.track },
  },
}));

// noinspection JSUnusedGlobalSymbols
export default fetchSalonTagsList;
